import moment from 'moment';

const store = {
    debug: process.env.NODE_ENV !== 'production',
    state: {
        auth: {},
        projects: [],
        currentProject: null,
        user: null
    },

    // Authentication

    accessTokenIsValid () {
        if (!this.state.auth.access_token) {
            return false;
        }
        return this.state.auth.access_expires > moment();
    },

    refreshTokenIsValid () {
        if (!this.state.auth.refresh_token) {
            return false;
        }
        return this.state.auth.refresh_expires > moment();
    },

    needsRefresh () {
        if (!this.refreshTokenIsValid()) {
            return false;
        }
        if (!this.accessTokenIsValid()) {
            return true;
        }
        // Refresh if one minute left
        if (this.state.auth.access_expires < moment().add(1, 'Minutes'))
            return true;
        return false;
    },

    isAuthenticated () {
        return (this.accessTokenIsValid() || this.refreshTokenIsValid());
    },

    setAuth (auth) {
        if (this.debug) console.log('setAuth triggered with', auth);
        if (!auth) {
            auth = {};
        }
        const newAuth = Object.assign({}, auth);
        if (!newAuth.access_expires) {
            newAuth.access_expires = moment().add(auth.expires_in, 'Seconds');
        }
        if (!newAuth.refresh_expires) {
            newAuth.refresh_expires = moment().add(auth.refresh_expires_in, 'Seconds');
        }
        this.state.auth = newAuth;
        localStorage.setItem('auth', JSON.stringify(newAuth));
    },

    setUser (user) {
        if (this.debug) console.log('setUser triggered with', user);
        this.state.user = user;
    },

    getRole () {
        if (!this.state.user) {
            return null;
        }
        return (this.state.user.role == 'admin') ? 'Администратор' : 'Пользователь';
    },

    getRefreshToken () {
        if (this.refreshTokenIsValid())
            return this.state.auth.refresh_token;
    },

    getAccessToken () {
        if (this.accessTokenIsValid())
            return this.state.auth.access_token;
    },

    // Navigation helper
    setCurrentProject (id) {
        if (id === null) {
            this.state.currentProject = null;
        } else {
            this.state.currentProject = this.state.projects.find(
                el => el.id === id
            );
        }
    },

    // Projects

    setProjects (projects) {
        if (this.debug) console.log('setProjects triggered with', projects);
        this.state.projects = projects;
    },

    findProject (projectId) {
        const id = parseInt(projectId);
        const project = this.state.projects.find(
            el => el.id === id
        );
        return project;
    },

};

// Load initial data
const auth = localStorage.getItem('auth');

if (auth) {
    const saved = JSON.parse(auth);
    saved.access_expires = moment(saved.access_expires);
    saved.refresh_expires = moment(saved.refresh_expires);
    store.setAuth(saved);
}

export { store };
